const TABLE_CONTENT_LARGE_GREY = "normal normal bold 16px/20px 'Noto Sans JP'";

const TABLE_HEAD_SMALL = "normal normal bold 12px/16px 'Noto Sans JP'";
const TABLE_CONTENT_SMALL = "normal normal bold 13px/20px 'Noto Sans JP'";

export { TABLE_CONTENT_LARGE_GREY, TABLE_CONTENT_SMALL, TABLE_HEAD_SMALL };
